import React, { useEffect } from 'react';
import { XMarkIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import useAgentChatStore from '../../../stores/agentChatStore';
import useConversations from '../../messaging/hooks/useConversations';

/**
 * Floating Action Button (FAB) to open/close the chat panel.
 * Single source of truth for conversation unread count — pushes to store.
 * Shows unread badge when panel is closed.
 */
export default function AgentChatButton() {
  const { isOpen, toggle, setConversationUnreadCount } = useAgentChatStore();
  const { unreadCount } = useConversations({ limit: 50, autoSubscribe: true });

  // Push unread count to store so AgentChat tab badge can read it without its own listener
  useEffect(() => {
    setConversationUnreadCount(unreadCount);
  }, [unreadCount, setConversationUnreadCount]);

  return (
    <div className="fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-40">
      <button
        onClick={toggle}
        className="btn btn-circle btn-primary shadow-lg btn-lg relative"
        aria-label={isOpen ? 'Close chat panel' : 'Open chat panel'}
      >
        {isOpen ? (
          <XMarkIcon className="w-6 h-6" />
        ) : (
          <ChatBubbleLeftRightIcon className="w-6 h-6" />
        )}
      </button>

      {/* Unread badge - only when panel is closed */}
      {!isOpen && unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[20px] h-[20px] flex items-center justify-center bg-error text-error-content text-[11px] font-bold rounded-full px-1 pointer-events-none">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </div>
  );
}
